import {
  IPayoutItem,
  IPayoutResponse
} from "../../../services/api/payments/payouts/types";
import { getPayoutNet } from "./utils";

export const getPayoutTotalAmount = (payout: IPayoutResponse): number =>
  getPayoutNet(payout);

export const selectorIsPayoutItemVisible = (payoutItem: IPayoutItem) =>
  payoutItem.sourceType === "Invoice" &&
  !payoutItem.description?.includes("Payout");
